import { render, staticRenderFns } from "./historyList.vue?vue&type=template&id=6da1ee64&scoped=true&"
import script from "./historyList.vue?vue&type=script&lang=js&"
export * from "./historyList.vue?vue&type=script&lang=js&"
import style0 from "./historyList.vue?vue&type=style&index=0&id=6da1ee64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da1ee64",
  null
  
)

export default component.exports